export default "__VITE_ASSET__KrT0sn_u__"